exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html{background:#f5f5f5}.wrapper{flex-direction:row;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:850px;border-radius:10px;background-color:#fff;box-shadow:0 30px 18px -24px rgba(0,0,0,.2)}.poster,.wrapper{display:flex;overflow:hidden}.poster{padding-left:30px;width:200px;flex-direction:column;align-items:center;justify-content:center;position:relative}.bracket-data{padding:40px 30px 40px 10px;width:100%}.image{position:relative;overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6aad3ed5","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/BracketSelect.vue
// module id = 20
// module chunks = 0